var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttachFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6871 6.41299C16.4019 6.12936 15.9408 6.13062 15.6572 6.41576L6.90313 15.2172C5.76739 16.3529 3.92279 16.3529 2.78494 15.2156C1.64795 14.0781 1.64795 12.2335 2.78508 11.0963L11.7983 2.03579C12.5073 1.32675 13.6601 1.32675 14.3713 2.03732C15.0822 2.74824 15.0822 3.9009 14.3711 4.61202L6.90449 12.0786C6.90401 12.079 6.9036 12.0796 6.90313 12.0801C6.61867 12.3629 6.15897 12.3626 5.87509 12.0787C5.59074 11.7943 5.59074 11.3335 5.87509 11.0491L9.47915 7.44431C9.7635 7.15989 9.76347 6.69878 9.47905 6.41443C9.19463 6.13008 8.73352 6.13011 8.44917 6.41453L4.84514 10.0193C3.99206 10.8724 3.99206 12.2554 4.84521 13.1085C5.69834 13.9617 7.08138 13.9617 7.93454 13.1085C7.93553 13.1075 7.93632 13.1065 7.93727 13.1055L15.4009 5.64183C16.6808 4.36194 16.6808 2.2871 15.4009 1.00721C14.1209 -0.271933 12.0462 -0.271933 10.767 1.00721L1.75384 10.0678C0.0492977 11.7724 0.0492975 14.5389 1.75507 16.2455C3.46196 17.9515 6.22853 17.9515 7.9344 16.2457L16.6899 7.44287C16.9735 7.1577 16.9722 6.69663 16.6871 6.41299Z",
    fill: "#3B404D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachFile);
export default __webpack_public_path__ + "static/media/attach_file.9572fb5ccf1f05f6e640568b8a201671.svg";
export { ForwardRef as ReactComponent };